import * as types from 'redux/actions/actionTypes';
import {
  GET_INSURANCE_COMPANY_BY_SLUG_REQUEST,
  GET_INSURANCE_COMPANY_BY_SLUG_SUCCESS,
  GET_INSURANCE_COMPANY_BY_SLUG_FAILURE,
  GET_INSURANCE_COMPANIES_REQUEST,
  GET_INSURANCE_COMPANIES_SUCCESS,
  GET_INSURANCE_COMPANIES_FAILURE,
  SET_INSURANCE_COMPANY,
  CLEAR_INSURANCE_COMPANY
} from 'redux/actions';
import { removeFailedRequest, removeOpenRequest } from 'utils';
import { InsuranceCompany } from 'domain/enitity';
import InsuranceCompanyState from 'redux/stores/insuranceCompanyState';

const initialState = InsuranceCompanyState.getInitialState();

export const insuranceCompanyReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGOUT_USER: {
      return initialState;
    }

    case GET_INSURANCE_COMPANIES_REQUEST: {
      return {
        ...state,
        openRequests: [...state.openRequests, action.type],
        failedRequests: removeFailedRequest(action, state),
        updatedAt: Date.now(),
        error: null
      };
    }

    case GET_INSURANCE_COMPANY_BY_SLUG_REQUEST: {
      return {
        ...state,
        openRequests: [...state.openRequests, action.type],
        failedRequests: removeFailedRequest(action, state),
        updatedAt: Date.now(),
        insuranceCompany: null,
        error: null
      };
    }

    case GET_INSURANCE_COMPANIES_SUCCESS: {
      return {
        ...state,
        openRequests: removeOpenRequest(action, state),
        updatedAt: Date.now(),
        entries: action.payload
      };
    }

    case SET_INSURANCE_COMPANY:
    case GET_INSURANCE_COMPANY_BY_SLUG_SUCCESS: {
      return {
        ...state,
        openRequests: removeOpenRequest(action, state),
        updatedAt: Date.now(),
        insuranceCompany: !!action.payload.insuranceCompany ? InsuranceCompany({ ...action.payload.insuranceCompany }) : null
      };
    }
    case CLEAR_INSURANCE_COMPANY: {
      return {
        ...state,
        updatedAt: Date.now(),
        insuranceCompany: null
      };
    }

    case GET_INSURANCE_COMPANIES_FAILURE:
    case GET_INSURANCE_COMPANY_BY_SLUG_FAILURE:
      return {
        ...state,
        openRequests: removeOpenRequest(action, state),
        failedRequests: [...state.failedRequests, action.type],
        updatedAt: Date.now(),
        error: action.error?.[0]?.extensions || action.error
      };

    default:
      return state;
  }
};
